import * as SwitchPrimitives from '@radix-ui/react-switch'
import { motion } from 'motion/react'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

import { springs } from '@/lib/motion/presets'
import { cn } from '@/lib/utils'

const Switch = forwardRef<
  ElementRef<typeof SwitchPrimitives.Root>,
  ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent px-0.5 shadow-sm transition-[color,box-shadow] focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:justify-end data-[state=checked]:bg-primary data-[state=unchecked]:justify-start data-[state=unchecked]:bg-input',
      className
    )}
    {...props}
    ref={ref}
  >
    {/*
      Thumb travel is driven by Motion's `layout` spring rather than the CSS
      `translate-x` transition: the Root's justify-start/justify-end flips the
      thumb's flexbox position on state change, and `layout` animates that
      position change with the shared `switchThumb` spring. `MotionConfig
      reducedMotion="user"` at the app root makes it snap for reduced-motion.
    */}
    <SwitchPrimitives.Thumb asChild>
      <motion.span
        layout
        layoutDependency={props.checked}
        transition={springs.switchThumb}
        className="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0"
      />
    </SwitchPrimitives.Thumb>
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
